import {
  assign, endpoint, options, check, convert,
} from '../helpers';

/**
 * Brings the report trend according to the configuration made
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const trend = (properties) => {
  const props = assign(properties);
  const model = {
    TableAndColumns: props.data.columns,
    Top: props.data.top,
    Query: props.data.query,
    Token: props.data.token,
  };

  fetch(endpoint('/report-trend'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        props.success(response.Data);
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default trend;
